import React, { useEffect } from 'react';
import PropKioskDashboard from './PropKioskDashboard';
import SearchV2 from './components/SearchV2';
import { ToastProvider } from './components/ui/ToastContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './i18n/LanguageContext';
import ToastContainer from './components/ui/ToastContainer';
import { RouterProvider } from 'react-aria-components';
import './App.css';

function App() {
  useEffect(() => {
    const handleResizeObserverLoopError = (event) => {
      if (
        event?.message &&
        event.message.includes('ResizeObserver loop completed with undelivered notifications.')
      ) {
        event.preventDefault();
      }
    };

    window.addEventListener('error', handleResizeObserverLoopError);
    return () => {
      window.removeEventListener('error', handleResizeObserverLoopError);
    };
  }, []);

  const searchParams = new URLSearchParams(window.location.search);
  const showV1 = searchParams.has('v1');
  const roleParam = searchParams.get('role');

  let content;
  if (showV1) {
    content = <PropKioskDashboard roleParam={roleParam} />;
  } else {
    content = <SearchV2 />;
  }

  return (
    <RouterProvider navigate={(path) => window.location.href = path}>
      <LanguageProvider>
        <ThemeProvider>
          <ToastProvider>
            <div className="App">
              {content}
              <ToastContainer />
            </div>
          </ToastProvider>
        </ThemeProvider>
      </LanguageProvider>
    </RouterProvider>
  );
}

export default App;
